import { Card, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import { LinkButton } from "@/components";

const LoggedOut = () => {
  const history = useHistory();

  return (
    <Card className="flex flex-col items-center gap-4 px-16 py-8">
      <Typography component="h1" variant="h1" align="center">
        You are signed out
      </Typography>

      <Typography component="h2" variant="body1" align="center">
        You can safely close this browser window
      </Typography>

      <LinkButton onClick={() => history.push("/")}>
        Log In
      </LinkButton>
    </Card>
  );
};

export default LoggedOut;

